module.exports = __webpack_public_path__ + "static/mettings-cover-18bb66f29f65e011386a7460e32a663d.png";